import { AfterViewInit, Component, EventEmitter, forwardRef, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subscription } from "rxjs";
import { AppConfigService } from 'src/app/appconfig/appconfig.service';
import { CommercialPlan, Plan } from 'src/app/_models/plan';
import { RatesResponse } from 'src/app/_models/rates';
import { getSurchargeAmountFromRates } from 'src/app/_utils/surcharge-lookup.util';
import { ProductTabsetService } from 'src/app/_services/product-tabset.service';
import brandInfo from "src/environments/brand.json";
import { CollapseComponent } from 'ng-uikit-pro-standard';
import { Cart } from 'src/app/_models/cart';
import { Lead } from 'src/app/_models/lead';
import { Opportunity } from 'src/app/_models/account';
import { Vehicle } from 'src/app/_models/vehicle';
import { updateCart } from 'src/app/_actions/cart.actions';
import { Tooltip } from 'chart.js';
import { environment } from 'src/environments/environment';
import { TaxSubmissionService } from 'src/app/_services/tax-submission.service';

@Component({
  selector: 'app-add-ons',
  standalone: false,
  templateUrl: './add-ons.component.html',
  styleUrls: ['./add-ons.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AddOnsComponent),
      multi: true
    }
  ]
})



export class AddOnsComponent implements ControlValueAccessor, OnInit {
  @ViewChildren(CollapseComponent) collapseComponents!: QueryList<CollapseComponent>
  @Output() chosenTerm = new EventEmitter<any>();
  surcharges: any = []
  hasVehicleServiceInCart = false;
  preferredLanguage: string;

  onChange: any = () => { };
  onTouch: any = () => { };
  dealerSub: Subscription;
  dealer: any;



  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  constructor(
    private store: Store<{
      dealer: any
    }>,
    private appConfig: AppConfigService,
    private taxSubmissionService: TaxSubmissionService
  ) { }

  ngOnInit(): void {
    this.preferredLanguage = sessionStorage.getItem("preferredLanguage") ? sessionStorage.getItem("preferredLanguage") : brandInfo.language;
    const _rates: RatesResponse = JSON.parse(sessionStorage.getItem("rates"))
    const _cart: Cart = JSON.parse(sessionStorage.getItem('cart'));

    this.hasVehicleServiceInCart = _cart?.plans?.some(
      (plan) => plan.productCategory === 'Vehicle Service'
    ) ? true : false;

    if(brandInfo.brand !== 'NCESI'){
      for (let i = 0; i < _rates.data.productDetailsList.length; i++) {
        for (let j = 0; j < _rates.data.productDetailsList[i].surcharge.surchargeOption.length; j++) {
          this.surcharges.push({
            ..._rates.data.productDetailsList[i].surcharge.surchargeOption[j],
            tooltip: this.getToolTip(_rates.data.productDetailsList[i].surcharge.surchargeOption[j].label.enLabel),
            active: this.getToggleActive(_rates.data.productDetailsList[i].surcharge.surchargeOption[j].label.enLabel)
          });
        }
      }
    }

    this.dealerSub = this.store.select((store) => store.dealer).subscribe((dealer) => {
      this.dealer = dealer;
    })

    console.log('surcharge', this.surcharges)
  }

  getToggleActive(surcharge) {
    const _cart: Cart = JSON.parse(sessionStorage.getItem("cart"));
    if (surcharge.toLowerCase().includes('Grey Market'.toLowerCase())) {
      return _cart.greyMarket;
    } else if (surcharge.toLowerCase().includes('VALET SERVICE'.toLowerCase())) {
      return _cart.valet;
    } else if (surcharge.toLowerCase().includes('Light Duty'.toLowerCase())) {
      return _cart.commercialUse;
    } else if (surcharge.toLowerCase().includes('Lift Kit'.toLowerCase())) {
      return _cart.liftKit;
    } else if (surcharge.toLowerCase().includes('Plow'.toLowerCase())) {
      return _cart.snowPlow;
    } else if (surcharge.toLowerCase().includes('Professional Services'.toLowerCase())) {
      return _cart.commercialUse;
    } else if (surcharge.toLowerCase().includes('Commercial'.toLowerCase())) {
      return _cart.commercialUse;
    }
  }

  getToolTip(surcharge) {
    if (surcharge.toLowerCase().includes('Grey Market'.toLowerCase())) {
      return this.appConfig.getGreyMarketTooltip();
    } else if (surcharge.toLowerCase().includes('VALET SERVICE'.toLowerCase())) {
      return this.appConfig.getCommercialUseTooltip();
    } else if (surcharge.toLowerCase().includes('Light Duty'.toLowerCase())) {
      return this.appConfig.getCommercialUseTooltip();
    } else if (surcharge.toLowerCase().includes('Lift Kit'.toLowerCase())) {
      return this.appConfig.getLiftKitTooltip();
    } else if (surcharge.toLowerCase().includes('Plow'.toLowerCase())) {
      return this.appConfig.getSnowPlowTooltip();
    } else if (surcharge.toLowerCase().includes('Professional Services'.toLowerCase())) {
      return this.appConfig.getCommercialUseTooltip();
    } else if (surcharge.toLowerCase().includes('Commercial'.toLowerCase())) {
      return this.appConfig.getCommercialUseTooltip();
    }
  }

  checked: boolean = false;
  writeValue(checked: boolean) {
    this.checked = checked;
  }


  onModelChange(surcharge, e: boolean) {
    // Step 5a: bind the changes to the local value
    console.log("onModelChange", surcharge, e)
    surcharge.active = e;
    this.handleAddOns(this.surcharges, surcharge, e)
  }

  toggleToolTip(index) {
    this.collapseComponents.toArray()[index].toggle()
  }

  handleAddOns(surcharges, surcharge, boolean) {
    let _cart: Cart = JSON.parse(sessionStorage.getItem("cart"));
    const previousSurchargeTotal = this.getCartSurchargeTotal(_cart);
    let surchargePrice = 0

    for (let i = 0; i < surcharges.length; i++) {
      if (surcharges[i].active) {
        surchargePrice += Number(surcharges[i].surchargeAmount)
      }
    }


    if (surcharge.label.enLabel.toLowerCase().includes('Grey Market'.toLowerCase())) {
      _cart.greyMarket = boolean;
    }

    if (
      surcharge.label.enLabel.toLowerCase().includes('VALET SERVICE'.toLowerCase())
    ) {
      _cart.valet = boolean;
    }

    if (surcharge.label.enLabel.toLowerCase().includes('Light Duty'.toLowerCase())) {
      _cart.commercialUse = boolean;
    }

    if (surcharge.label.enLabel.toLowerCase().includes('Commercial'.toLowerCase())) {
      _cart.commercialUse = boolean;
    }

    if (surcharge.label.enLabel.toLowerCase().includes('Professional Services'.toLowerCase())) {
      _cart.commercialUse = boolean;
    }

    if (surcharge.label.enLabel.toLowerCase().includes('Lift Kit'.toLowerCase())) {
      _cart.liftKit = boolean;
    }

    if (surcharge.label.enLabel.toLowerCase().includes('Plow'.toLowerCase())) {
      _cart.snowPlow = boolean;
    }

    const subtotalBase = Number(_cart.subtotal) - previousSurchargeTotal;
    _cart.subtotal = subtotalBase + surchargePrice;
    _cart.downPayment = brandInfo.brand === 'Hyundai' ? _cart.subtotal * .20 : _cart.subtotal * .10;

    // _cart.downPayment = this.getDownPayment(_cart)

    if (brandInfo.frontLoadTaxes) {
      _cart.monthlyPayment = Number((Number(_cart.subtotal) / Number(_cart.numberOfMonthlyPayments)).toFixed(2).toString());
    } else {
      //Handle downpayment here
      _cart.monthlyPayment = Number(((Number(_cart.subtotal) - Number(_cart.downPayment)) / Number(_cart.numberOfMonthlyPayments)).toFixed(2).toString());
    }

    this.store.dispatch(updateCart(_cart))
    console.log('addOns submitTax');

    this.submitTax(_cart)
  }

  getCartSurchargeTotal(cart: Cart): number {
    let total = 0;
    if (cart.commercialUse) {
      total += this.getSurchargeAmount('Professional Services');
      total += this.getSurchargeAmount('Commercial');
      total += this.getSurchargeAmount('LIGHT DUTY COMMERCIAL');
    }
    if (cart.liftKit) {
      total += this.getSurchargeAmount('Lift Kit');
    }
    if (cart.snowPlow) {
      total += this.getSurchargeAmount('Plow');
    }
    if (cart.greyMarket) {
      total += this.getSurchargeAmount('Grey Market');
    }
    if (cart.valet) {
      total += this.getSurchargeAmount('VALET SERVICE');
    }
    return total;
  }

  getSurchargeAmount(option: string): number {
    const raw = sessionStorage.getItem('rates');
    if (!raw) {
      return 0;
    }
    let rates: RatesResponse;
    try {
      rates = JSON.parse(raw);
    } catch {
      return 0;
    }
    return getSurchargeAmountFromRates(rates, option);
  }

  submitTax(cart: Cart) {
    const lead: Lead = JSON.parse(sessionStorage.getItem("lead"));
    const opp: Opportunity = JSON.parse(sessionStorage.getItem('opp'));
    const vehicle: Vehicle = JSON.parse(sessionStorage.getItem('vehicle'));

    this.taxSubmissionService.submitTaxRequest({
      cart: cart,
      lead: lead,
      opportunity: opp,
      vehicle: vehicle,
      dealer: this.dealer,
      useSubtotalForSingleProduct: true
    });
  }
}
